import { memo, ReactNode, SyntheticEvent } from 'react'
import cn from 'classnames'
import { getTypedCn } from 'helpers/getTypedCn'

import s from './Text.module.less'

export type TTextColor =
  | 'text'
  | 'secondary'
  | 'current'
  | 'placeholder'
  | 'inverted'
  | 'secondary-inverted'
  | 'accent'
  | 'attention'
  | 'green'
  | 'red'
  | 'error'
  | 'link'
  | 'blue'

export type TTextStyleName =
  | 'prominent'
  | 'headline1'
  | 'headline2'
  | 'headline3'
  | 'headline4'
  | 'headline5'
  | 'bodyProminent'
  | 'bodyLarge'
  | 'bodyDefault'
  | 'bodySection'
  | 'bodyCaption'
  | 'buttonProminent'
  | 'buttonDefault'
  | 'tableData'
  | 'tableHeader'
  | 'tabProminent'
  | 'tabDefault'
  | 'labelProminent'
  | 'labelDefault'
  | 'fieldProminent'
  | 'fieldDefault'

export interface ITextProps {
  /** Текст */
  children: ReactNode
  /** добавляет серый фон под текст, используется, например, для заглушек, когда информация не доступна  */
  background?: boolean
  /** display: block (true/false) */
  block?: boolean
  /** Кастомный класснейм */
  className?: string
  /** Цвет */
  color?: TTextColor
  /** Разбивает текст html тегом "br" по символу переносу строки */
  multiLine?: boolean
  /** Хендлер на клик */
  onClick?: (event: SyntheticEvent<HTMLSpanElement>) => void
  /** Название стиля текста */
  styleName?: TTextStyleName
  /** Тестовый атрибут */
  testId?: string
  /** HTML-атрибут */
  title?: string
}

export const Text = memo(function Text({
  styleName = 'bodyDefault',
  color = 'text',
  block,
  children,
  className,
  multiLine,
  background,
  testId,
  ...props
}: ITextProps) {
  let content = children

  if (multiLine && typeof content === 'string') {
    content = content
      .split('\n')
      .map((i) => i.trim())
      .reduce((p: ReactNode[], n, i) => [...p, !!i && <br key={i} />, n], [])
  }

  return (
    <span
      data-test-id={testId}
      className={cn(s.Text, className, s[styleName], getTypedCn(s, 'Text_color_', color), {
        [s.Text_block]: block,
        [s.Text_background]: background
      })}
      {...props}
    >
      {content}
    </span>
  )
})
